import { render, staticRenderFns } from "./rich-text-area.vue?vue&type=template&id=0424efa6&"
import script from "./rich-text-area.vue?vue&type=script&lang=js&"
export * from "./rich-text-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports